import {createContext} from "react";

export const StoreContextMain = createContext(null);